webpackJsonp([28523171363692],{

/***/ 1344:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AllergyInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-allergy-input-a93aef35447301da5bea.js